import React, {useContext} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {updatePromptParts} from "../aiApi";
import LoadingSpinner from "../../ui/loadingSpinner";
import TextInput from "../../ui/textInput";


const UiPopupAIContentFeatureGroups = (props) => {

  const {type} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {groupObjects, promptsList} = uiPopupContext;

  const isActiveType = "isActive" + type;
  const isActiveBody = "partBody" + type;
  const promptsPartsLoading = "promptsPartsLoading" + type;

  const onCheckboxClick = (gr) => {
    uiPopupDispatch({
      groupObjects: groupObjects.map(groupObject => {
        if (groupObject.partId === gr.partId) {
          groupObject.enabled = !groupObject.enabled;
        }
        return groupObject
      }),
    });
  }

  return (
    <ul className="ass-list pr-1 w-full">
      {groupObjects ? groupObjects.map(groupObject => {
        const onInputChange = (value) => {
          uiPopupDispatch({
            groupObjects: groupObjects.map(gr => {
              if (groupObject.partId === gr.partId) {
                gr[isActiveBody] = value;
              }
              return gr
            }),
          });
        }

        const onInputBlur = async () => {
          const activePrompt = promptsList.find(promptObject => promptObject[isActiveType]);
          if (!activePrompt) {
            return null
          }
          await updatePromptParts(groupObject, activePrompt, type);
        }

        return (
          <li key={groupObject.featureGroup.partId} className="ass-list__item">
            <FormControlLabel
              style={{width: "150px", flex: "0 0 150px", lineHeight: 1}}
              className="ll-text bold color-primary text-left"
              label={groupObject.featureGroup.dbName || groupObject.featureGroup.partName}
              control={<Checkbox
                checked={groupObjects.some(gr => gr.partId === groupObject.partId && gr.enabled)}
                onChange={() => onCheckboxClick(groupObject)}/>}
            />
            {uiPopupContext[promptsPartsLoading] ? <LoadingSpinner size=" message-loading-left-panel-spinner message-loading-left-panel-spinner--30 w-3"/> : (
              <TextInput className={"ui-input ui-input--new ui-input--gray"}
                         name={groupObject.partId}
                         onBlur={onInputBlur}
                         onChange={onInputChange}
                         onRealChange={onInputChange}
                         value={groupObject[isActiveBody] || ""}/>
            )}
          </li>
        )
      }) : null}
    </ul>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UiPopupAIContentFeatureGroups)
)

